// extracted by mini-css-extract-plugin
module.exports = {"emptyWrap":"Empty_emptyWrap__3qG-a","empt":"Empty_empt__7XGpB"};